import type { JSX, MouseEvent } from 'react';
import { useCallback } from 'react';

import { Text } from '@change/ds-core-ui/Text';

import { memo } from '@change-corgi/core-react/core';
import { parseHtml } from '@change-corgi/core-react/html';

import { BannerWrapper } from './BannerWrapper';

export const Banner = memo<{
	mobileContent: string;
	desktopContent: string;
	onLinkClick?: () => void;
}>(function Banner({
	mobileContent,
	desktopContent,
	onLinkClick,
}: {
	mobileContent: string;
	desktopContent: string;
	onLinkClick?: () => void;
}): JSX.Element {
	const onClick = useCallback(
		(event: MouseEvent) => {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			if ((event.target as HTMLElement).tagName === 'A') {
				onLinkClick?.();
			}
		},
		[onLinkClick],
	);

	// TODO might be better to use a replace function with parseHtml for the onClick
	return (
		<BannerWrapper big>
			{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
			<div onClick={onClick}>
				<div className="block md:hidden" data-testid="emergency-banner-mobile">
					<Text className="[&_a]:font-normal [&_a]:underline">{parseHtml(mobileContent)}</Text>
				</div>
				<div className="hidden md:block" data-testid="emergency-banner-desktop">
					<Text className="[&_a]:font-normal [&_a]:underline">{parseHtml(desktopContent)}</Text>
				</div>
			</div>
		</BannerWrapper>
	);
});
